const REGISTRATION_STARTED = 'USER.REGISTRATION_STARTED'
const REGISTRATION_COMPLETED = 'USER.REGISTRATION_COMPLETED'
const REGISTRATION_PROMO_MODAL_SHOWN = 'USER.REGISTRATION_PROMO_MODAL_SHOWN'

export {
  REGISTRATION_COMPLETED,
  REGISTRATION_STARTED,
  REGISTRATION_PROMO_MODAL_SHOWN,
}
